import linkedData from '../../../shared/components/PageHead/utils/linkedData'
import ogImage from '../images/family-search-building.jpg'

export default {
  en: {
    title: 'About FamilySearch',
    description:
      'FamilySearch provides free resources to help millions of people around the world discover their heritage and make family connections.',
    metaData: {
      ogTitle: 'The Largest Free Family History Resource',
      ogDescription: 'We inspire people everywhere to make family connections',
      ogImage,
    },
    linkedData,
  },
}
